<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <!-- <a ><img src="../assets/images/common/img_logo.png" alt=""></a> -->
                    <span>Face Mapping Registration</span>
                </div>
            </div>
        </header>
        <!-- // header -->

        <div id="content-wrap">
            <div id="contents">
                <!-- step info -->
                <div class="step-info-wrapper">
                    <div v-if="data.tunnelConstructionMethod === natm" class="container natm">
                        <ul>
                            <li @click="nextStep(data.tunnelConstructionMethod, 1)">
                                <span>STEP1.현장정보</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 2)">
                                <span>STEP2.이미지 매핑</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 3)">
                                <span>STEP3.이미지 크롭</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 4)">
                                <span>STEP4.막장 사진대지</span>
                            </li>
                            <li class="on" @click="nextStep(data.tunnelConstructionMethod, 5)">
                                <span>STEP5.강도정보</span>
                            </li>
                        </ul>
                    </div>
                    <div v-else class="container tbm">
                        <ul>
                            <li @click="nextStep(data.tunnelConstructionMethod, 1)">
                                <span>STEP1.현장정보</span>
                            </li>
                            <li @click="nextStep(data.tunnelConstructionMethod, 3)">
                                <span>STEP2.막장 사진대지</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- // step info -->

                <!-- gnb -->
                <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
                <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />
                <!-- // gnb -->

                <!-- detail-wrapper -->
                <div class="detail-wrapper write-detail-wrapper">
                    <div class="detail-box" :class="{ close: isCloseA }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: !isCloseA }" @click="isCloseA = !isCloseA">
                                <span>Face Mapping Note</span>
                            </a>
                        </div>
                        <div class="detail-contents">
                            <ul class="fms-note">
                                <li>
                                    <span>Construction Name</span>
                                    <span class="span-txt">
                                        {{ data.constructionNameValue }} {{ data.measureLocationName }}
                                    </span>
                                </li>
                                <li>
                                    <span>Station(STA No.)</span>
                                    <span class="span-txt"> STA NO.{{ data.station }} </span>
                                </li>
                                <li>
                                    <span>Tunnel Construction Method</span>
                                    <span class="span-txt">{{ data.tunnelConstructionMethodName }}</span>
                                </li>
                                <li>
                                    <span>Rock Type</span>
                                    <span class="span-txt">{{ data.rockTypeName }}</span>
                                </li>
                                <li>
                                    <span>Bearing</span>
                                    <span class="span-txt"> {{ data.bearing }} </span>
                                </li>
                                <li>
                                    <span>Jv</span>
                                    <span class="span-txt">{{ data.jvCount }} </span>
                                </li>
                                <li>
                                    <span>Geologist </span>
                                    <span class="span-txt"> {{ data.geologist }} {{ data.investigationDay }} </span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="detail-box" :class="{ close: isCloseB }">
                        <div class="detail-header">
                            <a class="view" :class="{ close: !isCloseB }" @click="isCloseB = !isCloseB">
                                <span>Data Sheet</span>
                            </a>
                        </div>
                        <div class="detail-contents">
                            <div class="detail-subheader">
                                <h3>1. 항목별 평가</h3>
                                <table class="type-simple">
                                    <colgroup>
                                        <col style="width:50px" />
                                        <col style="width:110px" />
                                        <col style="width:100px" />
                                        <col style="width:auto" />
                                    </colgroup>
                                    <tr>
                                        <td rowspan="3" class="border-right">
                                            ⓛ
                                        </td>
                                        <td class="border-weight border-right">점하중강도<br />(MPa)</td>
                                        <td>10이상</td>
                                        <td colspan="5">
                                            4-10
                                        </td>
                                        <td colspan="4">
                                            2-4
                                        </td>
                                        <td colspan="2">
                                            1-2
                                        </td>
                                        <td colspan="4" rowspan="2">
                                            일축압축강도 사용
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border-weight border-right">
                                            슈미트햄머
                                        </td>
                                        <td>60이상</td>
                                        <td colspan="5">
                                            51-60
                                        </td>
                                        <td colspan="4">
                                            44-51
                                        </td>
                                        <td colspan="2">
                                            34-44
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border-weight border-right">일축압축강도<br />(MPa)</td>
                                        <td>250이상</td>
                                        <td colspan="5">
                                            100-250
                                        </td>
                                        <td colspan="4">
                                            50-100
                                        </td>
                                        <td colspan="2">
                                            25-50
                                        </td>
                                        <td colspan="2">
                                            5-25
                                        </td>
                                        <td>1-5</td>
                                        <td>1미만</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="score border-weight border-right">
                                            점수 (R1)
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="15"
                                                    value="1"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">15</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="14"
                                                    value="2"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">14</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="13"
                                                    value="3"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">13</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="12"
                                                    value="4"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">12</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="11"
                                                    value="5"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">11</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="10"
                                                    value="6"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">10</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="9"
                                                    value="7"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">9</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="8"
                                                    value="8"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">8</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="7"
                                                    value="9"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">7</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="6"
                                                    value="10"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">6</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="5"
                                                    value="11"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">5</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="4"
                                                    value="12"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">4</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="3"
                                                    value="13"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">3</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="2"
                                                    value="14"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">2</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="1"
                                                    value="15"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">1</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    v-model="strengthIntackRockMaterialScore"
                                                    type="radio"
                                                    data-val="0"
                                                    value="16"
                                                    name="strengthIntackRockMaterialScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">0</span>
                                            </label>
                                        </td>
                                    </tr>
                                </table>

                                <div class="table-gap" />
                                <table class="type-simple">
                                    <colgroup>
                                        <col style="width:160px" />
                                        <col style="width:auto" />
                                    </colgroup>
                                    <tr>
                                        <td class="border-weight border-right">
                                            ② 암질계수(%)
                                        </td>
                                        <td colspan="3">
                                            90-100
                                        </td>
                                        <td colspan="3">
                                            75-90
                                        </td>
                                        <td colspan="5">
                                            50-75
                                        </td>
                                        <td colspan="6">
                                            25-50
                                        </td>
                                        <td>25미만</td>
                                    </tr>
                                    <tr>
                                        <td class="score border-weight border-right">
                                            점수 (R2)
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="20"
                                                    value="1"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">20</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input type="radio" data-val="19" value="2" name="rqdScore" />
                                                <span class="point">19</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="18"
                                                    value="3"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">18</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="17"
                                                    value="4"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">17</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="16"
                                                    value="5"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">16</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="15"
                                                    value="6"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">15</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="14"
                                                    value="7"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">14</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="13"
                                                    value="8"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">13</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="12"
                                                    value="9"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">12</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="11"
                                                    value="10"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">11</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="10"
                                                    value="11"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">10</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="9"
                                                    value="12"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">9</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="8"
                                                    value="13"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">8</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="7"
                                                    value="14"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">7</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="6"
                                                    value="15"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">6</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="5"
                                                    value="16"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">5</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="4"
                                                    value="17"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">4</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    data-val="3"
                                                    value="18"
                                                    name="rqdScore"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">3</span>
                                            </label>
                                        </td>
                                    </tr>
                                </table>

                                <div class="table-gap" />
                                <table class="type-simple">
                                    <colgroup>
                                        <col style="width:160px" />
                                        <col style="width:auto" />
                                    </colgroup>
                                    <tr>
                                        <td>
                                            ③ 절리면 간격
                                        </td>
                                        <td>2m이상</td>
                                        <td colspan="8">
                                            0.6-2m
                                        </td>
                                        <td colspan="4">
                                            0.2-0.6m
                                        </td>
                                        <td colspan="2">
                                            6-20cm
                                        </td>
                                        <td>6cm미만</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            점수 (R3)
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="1"
                                                    data-val="20"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">20</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="2"
                                                    data-val="19"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">19</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="3"
                                                    data-val="18"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">18</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="4"
                                                    data-val="17"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">17</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="5"
                                                    data-val="16"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">16</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="6"
                                                    data-val="15"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">15</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="7"
                                                    data-val="14"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">14</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="8"
                                                    data-val="13"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">13</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="9"
                                                    data-val="12"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">12</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="10"
                                                    data-val="11"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">11</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="11"
                                                    data-val="10"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">10</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="12"
                                                    data-val="9"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">9</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="13"
                                                    data-val="8"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">8</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="14"
                                                    data-val="7"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">7</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="15"
                                                    data-val="6"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">6</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="spacingJoinScore"
                                                    value="16"
                                                    data-val="5"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">5</span>
                                            </label>
                                        </td>
                                    </tr>
                                </table>

                                <div class="table-gap" />
                                <table class="type-simple">
                                    <colgroup>
                                        <col style="width:50px" />
                                        <col style="width:110px" />
                                        <col style="width:auto" />
                                    </colgroup>
                                    <tr>
                                        <td rowspan="6" class="border-right">④<br />절리면<br />상태</td>
                                        <td class="border-weight border-right">불연속면의<br />길이 (연속성)</td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_persitence"
                                                    value="1"
                                                    data-val="6"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">1m 미만<br />6</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_persitence"
                                                    value="2"
                                                    data-val="4"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">1-3m<br />4</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_persitence"
                                                    value="3"
                                                    data-val="2"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">3-10m<br />2</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_persitence"
                                                    value="4"
                                                    data-val="1"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">10-20m<br />1</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_persitence"
                                                    value="5"
                                                    data-val="0"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">20m 이상<br />0</span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border-weight border-right">불연속면의<br />간격 (틈새)</td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_aperture"
                                                    value="1"
                                                    data-val="6"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">없음<br />6</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_aperture"
                                                    value="2"
                                                    data-val="5"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">0.1mm 이하<br />5</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_aperture"
                                                    value="3"
                                                    data-val="4"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">0.1-1.0mm<br />4</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_aperture"
                                                    value="4"
                                                    data-val="1"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">1-5mm<br />1</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_aperture"
                                                    value="5"
                                                    data-val="0"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">5mm 이상<br />0</span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border-weight border-right">
                                            거칠기
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_roughness"
                                                    value="1"
                                                    data-val="6"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">매우 거침<br />(Very Rough)<br />6</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_roughness"
                                                    value="2"
                                                    data-val="5"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">거침<br />(Rough)<br />5</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_roughness"
                                                    value="3"
                                                    data-val="3"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">약간 거침<br />(Slightly Rough)<br />3</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_roughness"
                                                    value="4"
                                                    data-val="1"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">매끄러움<br />(Slickenside)<br />1</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_roughness"
                                                    value="5"
                                                    data-val="0"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">단층마찰면<br />(Fault Planar)<br />0</span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2" class="border-weight border-right">
                                            충전물
                                        </td>
                                        <td rowspan="2">
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_inFilling"
                                                    value="1"
                                                    data-val="6"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">없음<br />6</span>
                                            </label>
                                        </td>
                                        <td colspan="2">
                                            단단한 충전물
                                        </td>
                                        <td colspan="2">
                                            연약한 충전물
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_inFilling"
                                                    value="2"
                                                    data-val="4"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">5mm 미만<br />4</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_inFilling"
                                                    value="3"
                                                    data-val="2"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">5mm 이상<br />2</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_inFilling"
                                                    value="4"
                                                    data-val="2"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">5mm 미만<br />2</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_inFilling"
                                                    value="5"
                                                    data-val="0"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">5mm 이상<br />0</span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="border-weight border-right">
                                            풍화정도
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_wallStrength"
                                                    value="1"
                                                    data-val="6"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">풍화안됨<br />(Frash)<br />6</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_wallStrength"
                                                    value="2"
                                                    data-val="5"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">
                                                    약간 풍화<br />(Slightly Wathered)<br />5
                                                </span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_wallStrength"
                                                    value="3"
                                                    data-val="3"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">
                                                    풍화<br />(Moderately Wathered)<br />3
                                                </span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_wallStrength"
                                                    value="4"
                                                    data-val="1"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">
                                                    심한 풍화<br />(Hightly Wathered)<br />1
                                                </span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    class="ran_area"
                                                    name="Ran_wallStrength"
                                                    value="5"
                                                    data-val="0"
                                                    @change="conditionOfJointFn"
                                                />
                                                <span class="point-title">
                                                    파쇄(완전풍화)<br />(Completely Wathered)<br />0
                                                </span>
                                            </label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="score border-weight border-right">
                                            점수 (R4)
                                        </td>
                                        <td colspan="5">
                                            R4 (불연속면의 길이 + 불연속면의 간격 + 거칠기 + 충전물 + 풍화정도) =
                                            <span>
                                                <input
                                                    v-model="conditionJoinScore"
                                                    type="text"
                                                    class="txt result score-box"
                                                    value="0"
                                                    readonly
                                                />
                                            </span>
                                        </td>
                                    </tr>
                                </table>

                                <div class="table-gap" />
                                <table class="type-simple">
                                    <colgroup>
                                        <col style="width:50px" />
                                        <col style="width:110px" />
                                        <col style="width:auto" />
                                    </colgroup>
                                    <tr>
                                        <td rowspan="3" class="border-right">⑤<br />지하수</td>
                                        <td class="border-weight border-right">10m당<br />유입량</td>
                                        <td>없음</td>
                                        <td>10 (L/min)</td>
                                        <td>10-25(L/min)</td>
                                        <td>25-125(L/min)</td>
                                        <td>125초과(L/min)</td>
                                    </tr>
                                    <tr>
                                        <td class="border-weight border-right">절리수압/<br />최대주응력</td>
                                        <td>0</td>
                                        <td>0.1미만</td>
                                        <td>0.1-0.2</td>
                                        <td>0.2-0.5</td>
                                        <td>0.5초과</td>
                                    </tr>
                                    <tr>
                                        <td class="border-weight border-right">
                                            일반조건
                                        </td>
                                        <td>완전 건조<br />(Completely dry)</td>
                                        <td>습윤<br />(damp)</td>
                                        <td>젖어 있음<br />(wet)</td>
                                        <td>물방울 떨어짐<br />(dripping)</td>
                                        <td>물이 흐름<br />(flow)</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="score border-weight border-right">
                                            점수 (R5)
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="groundWaterRatioScore"
                                                    value="1"
                                                    data-val="15"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">15</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="groundWaterRatioScore"
                                                    value="2"
                                                    data-val="10"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">10</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="groundWaterRatioScore"
                                                    value="3"
                                                    data-val="7"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">7</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="groundWaterRatioScore"
                                                    value="4"
                                                    data-val="4"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">4</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="groundWaterRatioScore"
                                                    value="5"
                                                    data-val="0"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">0</span>
                                            </label>
                                        </td>
                                    </tr>
                                </table>

                                <div class="table-gap" />
                                <table class="type-simple">
                                    <colgroup>
                                        <col style="width:160px" />
                                        <col style="width:auto" />
                                        <col style="width:auto" />
                                        <col style="width:auto" />
                                        <col style="width:auto" />
                                    </colgroup>
                                    <tr>
                                        <td rowspan="3" class="border-weight border-right">
                                            ⑥ 절리방향에<br />따른 보정
                                        </td>
                                        <td colspan="4">
                                            주향이 터널방향과 수직
                                        </td>
                                        <td colspan="2" rowspan="2">주향이 터널 진행방향과<br />평행</td>
                                        <td rowspan="2">주향과<br />무관</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            경사방향 굴진
                                        </td>
                                        <td colspan="2">
                                            역경사 방향 굴진
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>45-90°</td>
                                        <td>20-45°</td>
                                        <td>45-90°</td>
                                        <td>20-45°</td>
                                        <td>45-90°</td>
                                        <td>20-45°</td>
                                        <td>0-20°</td>
                                    </tr>
                                    <tr>
                                        <td class="score border-weight border-right">
                                            점수 (R6)
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="orientationScore"
                                                    value="1"
                                                    data-val="0"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">0</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="orientationScore"
                                                    value="2"
                                                    data-val="-2"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">- 2</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="orientationScore"
                                                    value="3"
                                                    data-val="-5"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">- 5</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="orientationScore"
                                                    value="4"
                                                    data-val="-10"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">- 10</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="orientationScore"
                                                    value="5"
                                                    data-val="-12"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">- 12</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="orientationScore"
                                                    value="6"
                                                    data-val="-5"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">- 5</span>
                                            </label>
                                        </td>
                                        <td>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name="orientationScore"
                                                    value="7"
                                                    data-val="-5"
                                                    @change="countRmrScore"
                                                />
                                                <span class="point">- 5</span>
                                            </label>
                                        </td>
                                    </tr>
                                </table>

                                <div class="table-gap" />
                                <table class="type-simple">
                                    <colgroup>
                                        <col style="width:50px" />
                                        <col style="width:110px" />
                                        <col style="width:auto" />
                                    </colgroup>
                                    <tr>
                                        <td rowspan="3" class="border-right">암반<br />평가</td>
                                        <td class="border-weight border-right">RMR<br />평가</td>
                                        <td>100 - 81</td>
                                        <td>80 - 61</td>
                                        <td>60 - 41</td>
                                        <td>40 - 21</td>
                                        <td>20</td>
                                        <td>비고</td>
                                    </tr>
                                    <tr>
                                        <td class="border-weight border-right">
                                            암반상태
                                        </td>
                                        <td>매우우수</td>
                                        <td>우 수</td>
                                        <td>양 호</td>
                                        <td>불 량</td>
                                        <td>매우불량</td>
                                        <td />
                                    </tr>
                                    <tr>
                                        <td class="border-weight border-right">
                                            TYPE
                                        </td>
                                        <td><input v-if="rmrScore > 80" type="radio" name="decideType" checked />Ⅰ</td>
                                        <td>
                                            <input
                                                v-if="rmrScore > 60 && rmrScore <= 80"
                                                type="radio"
                                                name="decideType"
                                                checked
                                            />Ⅱ
                                        </td>
                                        <td>
                                            <input
                                                v-if="rmrScore > 40 && rmrScore <= 60"
                                                type="radio"
                                                name="decideType"
                                                checked
                                            />Ⅲ
                                        </td>
                                        <td>
                                            <input
                                                v-if="rmrScore > 20 && rmrScore <= 40"
                                                type="radio"
                                                name="decideType"
                                                checked
                                            />Ⅳ
                                        </td>
                                        <td><input v-if="rmrScore <= 20" type="radio" name="decideType" checked />Ⅴ</td>
                                        <td />
                                    </tr>
                                </table>

                                <div class="table-gap" />
                                <table class="type-simple">
                                    <colgroup>
                                        <col style="width:160px" />
                                        <col style="width:auto" />
                                        <col style="width:160px" />
                                        <col style="width:auto" />
                                    </colgroup>
                                    <tr>
                                        <td class="score border-weight border-right">
                                            2. 총 점<br /><span class="font-small">(R1+R2+R3+R4+R5+R6)</span>
                                        </td>
                                        <td>
                                            <input v-model="rmrScore" type="text" class="txt result" readonly />
                                        </td>
                                        <td class="score border-weight border-right">
                                            3. TYPE 결정
                                        </td>
                                        <td>
                                            <input v-model="data.decisionRockType" type="text" class="txt result" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="approval-box">
                        <div class="container">
                            <div class="field-box">
                                <div class="label">
                                    결재라인 설정
                                </div>
                                <div class="field">
                                    <div class="select-box">
                                        <select v-model="data.groupNo" @change="onChangedApprovalLine">
                                            <option value="0">
                                                결재라인을 설정하세요.
                                            </option>
                                            <option
                                                v-for="(item, index) in templateList"
                                                :key="index"
                                                :value="item.groupNo"
                                            >
                                                {{ item.templateName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="approval-line-preview">
                                        <span v-for="(data, index) in approvalList" :key="index" class="volume-box">
                                            {{ data.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="btn-wrapper bottom-fixed">
                        <button type="button" class="btn btn-cancel" @click="prev(data.tunnelConstructionMethod, 3)">
                            <span>이전으로</span>
                        </button>
                        <button type="button" class="btn btn-next" @click="save(false)">
                            <span>임시 저장</span>
                        </button>
                        <button type="button" class="btn btn-delete" @click="save(true)">
                            <span>결재 요청</span>
                        </button>
                    </div>

                    <confirm :param="confirmParam" @confirmCallback="confirmCallback" />
                </div>
                <!-- // detail-wrapper -->
            </div>
        </div>
    </body>
</template>
<script>
import { mapActions, mapState } from 'vuex';
//import MutationTypes from './../../store/MutationTypes';
import ApprovalApi from '../../api/ApprovalApi';
import CodeApi from '../../api/CodeApi';
import FacemappingApi from '../../api/FacemappingApi';
import { COMM_CODE, TUNNEL_CONSTRUCTION } from './../../const';
import confirm from './../common/Confirm.vue';
import gnb from './../layout/gnb.vue';

export default {
    name: 'Step4',
    components: {
        gnb,
        confirm
    },
    data: () => {
        return {
            id: null,
            data: {
                groupNo: 0,
                rmrScore: 0
            },
            rockNameList: {},
            groundWaterRatioList: [],
            isCloseA: false,
            isCloseB: false,
            rmrScore: 0,
            gnbShow: '',
            confirmParam: {
                msg: '',
                isShow: false,
                callbackParam: {}
            },
            natm: TUNNEL_CONSTRUCTION.NATM,
            templateList: [],
            approvalList: [],
            rmrType: '',
            conditionJoinScore: 0,
            groundWaterRatioScore: 0,
            orientationScore: 0,
            rqdScore: 0,
            spacingJoinScore: 0,
            strengthIntackRockMaterialScore: 0,
            isApproval: false
        };
    },
    computed: {
        ...mapState({
            stateData: state => {
                return JSON.parse(JSON.stringify(state.facemapping.data));
            }
        })
    },
    beforeCreate() {},
    created() {
        this.id = this.$route.params.id;
        if (this.id !== null) {
            this.dataObj();
        }
        if (this.data.faceMappingStrength === null) {
            this.data.faceMappingStrength = {
                masterId: this.$route.params.id,
                strengthId: null,
                groundWaterRatio: '',
                rockName: '014001',
                conditionJoinScore: 0,
                groundWaterRatioScore: 0,
                orientationScore: 0,
                rqdScore: 0,
                spacingJoinScore: 0,
                strengthIntackRockMaterialScore: 0
            };
            this.data.faceMappingSectionList = [
                {
                    aperture: '',
                    id: { masterId: this.$route.params.id, sectionDivisionCd: 'Ran' },
                    inFilling: '',
                    persitence: '',
                    roughness: '',
                    spacingJoint: '',
                    wallStrength: ''
                }
            ];
        }
    },
    mounted() {
        //ScreenHelper.setPortrait();
        window.scrollTo(0, 0);
        this.id = this.$route.params.id;
        this.data.faceMappingStrength.masterId = this.$route.params.id;
        this.codeSettign(COMM_CODE.rockName);

        this.hideLoading();
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading', 'alert']),
        backbtn() {
            this.$router.go(-1);
        },
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        async dataObj() {
            this.showLoading();
            const res = await ApprovalApi.getTemplateList();
            this.templateList = res.content;

            FacemappingApi.detail(this.id).then(res => {
                this.data = res.content;
                const strengthData = this.data.faceMappingStrength;
                $.each(strengthData, function(k, v) {
                    if (v) $('input:radio[name=' + k + ']:input[value=' + v + ']').prop('checked', true);
                });

                var sectionList = this.data.faceMappingSectionList;

                $.each(sectionList, function(idx, val) {
                    var sectionDivisionCd = val.id.sectionDivisionCd;
                    if (sectionDivisionCd === 'Ran') {
                        $.each(this, function(k, v) {
                            //console.log(k,v)
                            if (k !== 'id') {
                                $('input:radio[name=' + sectionDivisionCd + '_' + k + ']:input[value=' + v + ']').prop(
                                    'checked',
                                    true
                                );
                            }
                        });
                    }
                });

                //that.countRmrScore();
                this.conditionOfJointFn();
                this.hideLoading();
            });

            ApprovalApi.getLine(this.id).then(res => {
                this.approvalList = res.content;
            });
        },
        conditionOfJointFn() {
            var persitence = $('input[name=Ran_persitence]:checked').data('val') || 0;
            var aperture = $('input[name=Ran_aperture]:checked').data('val') || 0;
            var roughness = $('input[name=Ran_roughness]:checked').data('val') || 0;
            var filling = $('input[name=Ran_inFilling]:checked').data('val') || 0;
            var strength = $('input[name=Ran_wallStrength]:checked').data('val') || 0;

            this.conditionJoinScore =
                parseInt(persitence) +
                parseInt(aperture) +
                parseInt(roughness) +
                parseInt(filling) +
                parseInt(strength);

            this.countRmrScore();
            this.createSectionParam();
        },
        createSectionParam() {
            var persitence = $('input[name=Ran_persitence]:checked').val() || 0;
            var aperture = $('input[name=Ran_aperture]:checked').val() || 0;
            var roughness = $('input[name=Ran_roughness]:checked').val() || 0;
            var filling = $('input[name=Ran_inFilling]:checked').val() || 0;
            var strength = $('input[name=Ran_wallStrength]:checked').val() || 0;

            const faceMappingSectionList = [];

            faceMappingSectionList.push({
                id: { masterId: this.$route.params.id, sectionDivisionCd: 'Ran' },
                persitence: persitence,
                aperture: aperture,
                roughness: roughness,
                inFilling: filling,
                wallStrength: strength
            });
            this.data.faceMappingSectionList = faceMappingSectionList;
        },
        nextStep(tunnelConstructionMethod, step) {
            if (step === 5) return;

            if (step === 4) {
                if (tunnelConstructionMethod === TUNNEL_CONSTRUCTION.NATM)
                    this.$router.push({ path: `/step` + step + `/${this.data.id}` });
                else this.$router.push({ path: `/step` + step + `TBM/${this.data.id}` });
            } else {
                this.$router.push({ path: `/step` + step + `/${this.data.id}` });
            }
        },

        prev(tunnelConstructionMethod, step) {
            if (tunnelConstructionMethod === TUNNEL_CONSTRUCTION.NATM)
                this.$router.push({ path: `/step` + step + `/${this.data.id}` });
            else this.$router.push({ path: `/step` + step + `TBM/${this.data.id}` });
        },
        save(isApproval) {
            this.isApproval = isApproval;
            this.confirmParam.msg = '임시저장 하시겠습니까?';
            if (isApproval) {
                if (this.data.groupNo === 0 || this.data.groupNo === '0') {
                    var param = {};
                    param.isShow = true;
                    param.msg = '결재라인을 설정하세요.';
                    this.alert(param);
                    return;
                }
                this.confirmParam.msg = '결재요청 하시겠습니까??';
            }

            var callbackParam = {};
            this.confirmParam.isShow = true;
            this.confirmParam.callbackParam = callbackParam;
        },
        confirmCallback() {
            this.showLoading();
            var param = this.data.faceMappingStrength || { masterId: this.id };

            param.faceMappingSectionList = this.data.faceMappingSectionList;
            param.groupNo = this.data.groupNo;
            param.decisionRockType = this.data.decisionRockType;
            param.rmrScore = this.rmrScore;
            if (this.isApproval) {
                param.approveState = 'waiting';
            }

            ApprovalApi.postLine({ id: this.data.id, groupNo: param.groupNo }).then(() => {
                FacemappingApi.postStrength(param).then(() => {
                    this.hideLoading();
                    var param = {};
                    param.isShow = true;
                    param.msg = '저장 되었습니다.';
                    this.alert(param);
                    if (this.isApproval) {
                        this.$router.push({
                            name: 'List'
                        });
                    } else {
                        this.dataObj();
                    }
                });
            });
        },

        codeSettign(code) {
            var that = this;
            CodeApi.subCodeList(code, 2).then(res => {
                that.rockNameList = res.content;
            });
        },
        changeRockName(name) {
            if (name !== '014004') this.data.faceMappingStrength.rockNameEtc = '';
        },
        countRmrScore() {
            console.log('countRmrScore');
            const strengthIntackRockMaterialScore =
                $('input[name=strengthIntackRockMaterialScore]:checked').data('val') || 0;

            this.bindRqdScore();

            const rqdScore = $('input[name=rqdScore]:checked').data('val') || 0;
            const spacingJoinScore = $('input[name=spacingJoinScore]:checked').data('val') || 0;
            const groundWaterRatioScore = $('input[name=groundWaterRatioScore]:checked').data('val') || 0;
            const orientationScore = $('input[name=orientationScore]:checked').data('val') || 0;

            if (this.data.faceMappingStrength !== null) {
                this.rmrScore =
                    Number(this.conditionJoinScore || 0) +
                    Number(groundWaterRatioScore) +
                    Number(orientationScore) +
                    Number(rqdScore) +
                    Number(spacingJoinScore) +
                    Number(strengthIntackRockMaterialScore);
            }
            this.displayType(this.rmrScore);

            this.strengthIntackRockMaterialScore = $('input[name=strengthIntackRockMaterialScore]:checked').val();
            this.rqdScore = $('input[name=rqdScore]:checked').val();
            this.spacingJoinScore = $('input[name=spacingJoinScore]:checked').val();
            this.groundWaterRatioScore = $('input[name=groundWaterRatioScore]:checked').val();
            this.orientationScore = $('input[name=orientationScore]:checked').val();

            if (!this.data.faceMappingStrength) {
                this.data.faceMappingStrength = {
                    masterId: this.id,
                    strengthId: null,
                    groundWaterRatio: '',
                    conditionJoinScore: 0,
                    groundWaterRatioScore: 0,
                    orientationScore: 0,
                    rqdScore: 0,
                    spacingJoinScore: 0,
                    strengthIntackRockMaterialScore: 0
                };
            }

            this.data.faceMappingStrength.conditionJoinScore = Number(this.conditionJoinScore || 0);
            this.data.faceMappingStrength.groundWaterRatioScore = Number(this.groundWaterRatioScore || 0);
            this.data.faceMappingStrength.rqdScore = Number(this.rqdScore || 0);
            this.data.faceMappingStrength.spacingJoinScore = Number(this.spacingJoinScore || 0);
            this.data.faceMappingStrength.orientationScore = Number(this.orientationScore || 0);
            this.data.faceMappingStrength.strengthIntackRockMaterialScore = Number(
                this.strengthIntackRockMaterialScore || 0
            );
            //console.log(this.data.faceMappingStrength);
        },
        displayType(rmr) {
            var type = '';
            if (rmr >= 81) {
                type = 'Ⅰ';
            } else if (rmr >= 61) {
                type = 'Ⅱ';
            } else if (rmr >= 41) {
                type = 'Ⅲ';
            } else if (rmr >= 21) {
                type = 'Ⅳ';
            } else {
                type = 'Ⅴ';
            }
            this.rmrType = 'TYPE ' + type;
        },
        onChangedApprovalLine() {
            //var selectedValue = $(this).val();
            var selectedValue = this.data.groupNo;
            if (selectedValue === '0') {
                this.approvalList = [];
            } else {
                this.templateList.forEach(item => {
                    if (item.groupNo === selectedValue) {
                        this.approvalList = item.members;
                    }
                });
            }
        },
        bindRqdScore() {
            var point = this.jvPoint(this.data.jvCount);
            $('input[name=rqdScore][data-val="' + point + '"]').prop('checked', true);
        },
        jvPoint(jvCount) {
            //data.jvCount;
            if (isNaN(jvCount)) {
                return;
            }

            if (jvCount <= 5) return 20;
            else if (jvCount <= 6) return 19;
            else if (jvCount <= 7) return 18;
            else if (jvCount <= 9) return 17;
            else if (jvCount <= 11) return 16;
            else if (jvCount <= 12) return 15;
            else if (jvCount <= 14) return 14;
            else if (jvCount <= 15) return 13;
            else if (jvCount <= 17) return 12;
            else if (jvCount <= 18) return 11;
            else if (jvCount <= 19) return 10;
            else if (jvCount <= 20) return 9;
            else if (jvCount <= 21) return 8;
            else if (jvCount <= 23) return 7;
            else if (jvCount <= 24) return 6;
            else if (jvCount <= 26) return 5;
            else if (jvCount <= 27) return 4;
            else if (jvCount >= 28) return 3;
            else return 0;
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
